import { AuthEntry } from '@anm/api/modules/auth';
import { TermsUseProvider } from '@anm/components/TermsUse';
import { getWaveLinks } from '@anm/data/links';
import compose from 'lodash/fp/compose';
import React, { FC } from 'react';

import bootstrapPage, { BootstrapPageProps } from '../HOCs/bootstrapPage';
import injectSagasAndReducers from '../HOCs/injectSagasAndReducers';
import withSignUpRedirectNotification from '../HOCs/withSignUpRedirectNotification';
import { TitleTextVariants } from '../components/auth/AuthSection';
import SignUpMetaHead from '../components/auth/signup/SignUpMetaHead';
import SignUpSection from '../components/auth/signup/SignUpSection';
import Layout from '../components/layouts/Layout';
import vtConfig from '../config';
import { RouterRedirectQuery } from '../helpers/redirects/reactRouterRedirect';
import collapseReducer, { collapseSaga } from '../store/modules/collapse';

export type SignUpQuery = RouterRedirectQuery & {
  entry: AuthEntry;
};

export const titleTextVariants: TitleTextVariants = {
  welcome: {
    title: 'Sign up for free',
    description:
      '<span>Create, host, and share your videos with Wave.video.</span> Video hosting, online video editor, content calendar, and hundreds of professionally designed templates included.'
  }
};

const { urls, isProd } = vtConfig();
const { termsUse, privacyPolicy } = getWaveLinks({
  isProd,
  waveUrl: urls.wave
});

const SignUpPage: FC<BootstrapPageProps> = ({ path }) => {
  return (
    <>
      <SignUpMetaHead path={path} />
      <Layout navigationVariant="white" mainVariant="contain">
        <TermsUseProvider
          value={{
            termsLink: termsUse,
            privacyLink: privacyPolicy
          }}
        >
          <SignUpSection titleTextVariants={titleTextVariants} backgroundVariant="white-to-light-blue" />
        </TermsUseProvider>
      </Layout>
    </>
  );
};

export default compose(
  bootstrapPage,
  withSignUpRedirectNotification,
  injectSagasAndReducers(
    () => [...collapseSaga()],
    {
      collapse: collapseReducer
    },
    { id: 'SignUpPage' }
  )
)(SignUpPage);
